import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Col, Row } from "styles";
import { Table } from "../../style";

export function OrganicAcids(props) {
  return (
    <>
      <Row>
        <Col>
          <div
            style={{
              textAlign: "end",
              marginRight: "40px",
            }}
          >
            <Input
              type="checkbox"
              params="additions.organicAcids.unknownConcept"
              item={props.broiler}
              setItem={props.setBroiler}
              label="Cliente não conhece o conceito"
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table>
            <Header>
              <tr>
                <th style={{ width: "185px" }}>
                  <span></span>
                </th>
                <th>
                  <span>Qual Produto?</span>
                </th>
                <th>
                  <span>Qual Finalidade?</span>
                </th>
                <th>
                  <span>Qual Dose?</span>
                </th>
              </tr>
            </Header>
            <Body>
              <tr>
                <td>Pré</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.organicAcids.pre.product"
                    item={props.broiler}
                    setItem={props.setBroiler}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.organicAcids.pre.reason"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.organicAcids.pre.dose"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
              </tr>
              <tr>
                <td>Inicial</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.organicAcids.initial.product"
                    item={props.broiler}
                    setItem={props.setBroiler}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.organicAcids.initial.reason"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.organicAcids.initial.dose"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
              </tr>
              <tr>
                <td>Crescimento 1</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.organicAcids.growth.product"
                    item={props.broiler}
                    setItem={props.setBroiler}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.organicAcids.growth.reason"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.organicAcids.growth.dose"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
              </tr>
              <tr>
                <td>Crescimento 2</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.organicAcids.growth2.product"
                    item={props.broiler}
                    setItem={props.setBroiler}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.organicAcids.growth2.reason"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.organicAcids.growth2.dose"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
              </tr>

              <tr>
                <td>Final</td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.organicAcids.final.product"
                    item={props.broiler}
                    setItem={props.setBroiler}
                    placeholder="Digite o Produto"
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.organicAcids.final.reason"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
                <td>
                  <Input
                    type="inputOnly"
                    params="additions.organicAcids.final.dose"
                    item={props.broiler}
                    setItem={props.setBroiler}
                  />
                </td>
              </tr>
            </Body>
          </Table>
        </Col>
      </Row>
    </>
  );
}
